<template>
    <div class="gglist">
        <div class="top" v-show="dataLoding == 1">
            <Table style="width: 100%;margin-top: 30px;" :Loading='loading' :columns="titleName" :data="tableList.tableData"  ref="selection"></Table>
        </div>
        <!-- <Spin fix class="bottom" v-show="dataLoding == 2">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin> -->
    
    </div>
</template>
<script>
/**
 * 没有采用下拉查看图片
 * 
 */
import common from '@/common/common.js';
import moment from "moment";
export default {
    name:'editad',
    components: {
    },
    props: {
        params: {
            type:Object,
            default:{}
        },
        // titleNameS:{
        //     type:Array,
        //     default:[]
        // }
      
    },
    data () {
        return {
            dataLoding:1,
            loading: true,
            type:1,//弹框打开类型 1添加 2编辑
            tableList:{
                tableData:[]
            },
        }
    },
    computed:{
        titleName(){
            return [//用户号，邮箱，手机，地址，状态(在线/离线), APP操作系统，APP版本，活跃度，注册时间
                {
                    title: this.$t('userManage.userAccount'),
                    key: 'id',
                    width: 140,
                },
                {
                    title: this.$t('userManage.emailAddress'),
                    key: 'emailAddress',
                    width: 300,
                },
                {
                    title: this.$t('userManage.phoneNumber'),
                    key: 'phoneNumber',
                    width: 180,
                },
               
                {
                    title: this.$t('userManage.titleName.Status'),
                    key: 'whetherOnline',
                    width: 120,
                    render:(h, params)=>{
  
                         let stext = params.row.whetherOnline?this.$t('selectList.onlineType.Online'):this.$t('selectList.onlineType.Outline')
        
                         return h('div',{
                             style:{
                                 color:!params.row.whetherOnline?'#ed4014':'#5a516e'
                             }
                         },stext || '')
                    }
                },
                {
                    title: this.$t('userManage.titleName.Operational'),
                    key: 'os',
                    width: 140,
                    render:(h, params)=>{
                         let obj = {'1':'android','2':'ios'}
                         let stext = obj[params.row.os]
                         return h('div',stext || '')
                    }
                },
                {
                    title: this.$t('loginStatistics.titleName.App'),
                    key: 'appVersion',
                    width: 140,
                },
                {
                    title: this.$t('userManage.titleName.Liveness'),
                    key: 'liveness',
                    width: 100,
                },
                {
                    title: this.$t('userManage.titleName.Contact_address'),
                    key: 'area',
                    minWidth: 100,
                },
                {
                    title: this.$t('userManage.titleName.Registration_time'),
                    key: 'createdAt',
                    minWidth: 180,
                    render:(h, params)=>{
                        let stext = moment(params.row.createdAt*1).format('YYYY-MM-DD HH:mm:ss')
                         return h('div',stext || '')
                    }
                },
            ]
        }
    },
    methods: {
        getData () {//获取信息
            if(!this.params.userId) return
            this.loading = true
            this.axios.post(this.config.urlArray.getDeviceOneUser, {userId:this.params.userId}).then(result => {
                common.ajaxMsg(result.data,false,()=>{
                //   console.log(result.data)
                  this.tableList.tableData = [result.data.data]
                  this.loading = false
              },()=>{
                 this.loading = false
              })
 
		    })
        }
    },
    created(){
        // console.log(9999)
        // console.log(this.params)
    },
    watch:{
        // 'params.userId': {
        //     handler: function (newValue, oldValue) {
        //   },
        //   deep: true,
        //   immediate: true
        // }
    },
    mounted(){
       this.getData();
          
     }
}
</script>
<style scope>
.ivu-poptip-confirm .ivu-poptip-body .ivu-icon{
    left: 20px;
}
td.ivu-table-expanded-cell{
    padding: 10px !important;
}
.gglist .ivu-table th{
    height: 30px !important;
}
</style>
